// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"bd696ef2","450":"92e336bf","891":"572fb095"}[chunkId] + ".chunk.js";
};